import clsx from "clsx";

function getScaleItems(id: string, factor: number) {
  const result = [];

  for (let item = 0; item <= 10; item += 1) {
    result.push(
      <span
        id={`${id}--risk-score-scale--scale-item-${item}`}
        className={clsx(
          "risk-score-scale__item",
          item === factor && "risk-score-scale__item--current-score"
        )}
        key={item}
        data-testid={item === factor ? `risk_score_scale_item_active` : null}
      >
        {[0, 5, 10, factor].includes(item) && item}
      </span>
    );
  }
  return result;
}

type Props = {
  id?: string;
  classification: string;
  factor: number;
};

const RiskScoreScale = ({ id, classification, factor }: Props) => {
  const scaleItems = getScaleItems((id = ""), factor);
  return (
    <div
      data-testid="risk-score-scale"
      className={`risk-score-scale risk-score-scale--${classification}`}
    >
      {scaleItems}
    </div>
  );
};

export default RiskScoreScale;
